export const cellPadding = '10px 12px 10px 16px';
export const compactPadding = '5px 15px';
export const superCompactPadding = '5px';
